import { gql } from "lib/apolloClient";

const lastMessage = gql`
  fragment lastMessage on Message {
    id
    isRead
    createdAt
    label
    attachments {
      id
      name
      title
      mimeType
      type
    }
    createdBy {
      id
      firstName
      middleName
      lastName
      profileImage
      type
    }
    parentEntity {
      id
      ... on Conversation {
        id
        parentType
        parentEntity {
          id
        }
      }
    }
    __typename
  }
`;

const classDiscussion = gql`
  fragment classDiscussion on Conversation {
    id
  }
`;

const messagesSummary = gql`
  fragment messagesSummary on AssignmentMessagesSummary {
    unreadMessages(first: $messagesSummaryItemCount){
      ...lastMessage
    }
    unreadMessagesCount
    ${lastMessage}
  }
`;

export const ADMFragment = {
  teacherAssignmentItem: gql`
    fragment teacherAssignmentItem on Assignment {
      id
      isStudentSubmissionEnabled
      isTeacherEvaluationEnabled
      isClassDiscussionEnabled
      isSimilarityCheckEnabled
      isExcludedFromFinalGradeCalculation
      isPrivate
      course {
        id
        title
      }
      state {
        state
        publishedAt
        updatedAt
      }
      publishedAt
      deadline
      createdAt
      closeSubmissionDate
      content {
        id
        ... on Assessment {
          id
          title {
            id
            value
            __typename
          }
          assessmentType {
            id
            value
            __typename
          }

          category {
            id
            label
            __typename
          }
          __typename
        }
        ... on AssignmentResource {
          id
          label
          assignmentTitle: title
          __typename
        }
        __typename
      }

      summaryCounts {
        assigned
        evaluated
        turnedIn
        evaluationShared
        draftSubmissions
        newSubmissionsCount
        evaluationPending
        evaluationSharedPending
        evaluationApplicable
        __typename
      }
      messagesSummary @include(if: $includeMessagesSummary) {
        ...messagesSummary
        __typename
      }
      classDiscussion @include(if: $includeMessagesSummary) {
        ...classDiscussion
      }
    }
    ${classDiscussion}
    ${messagesSummary}
  `,
};
